<template>
    <v-container fill-height justify-center v-if="progress">
        <div class="text-center">
            <v-progress-circular
                :rotate="2"
                :size="100"
                :width="10"
                color="primary"
                indeterminate
            >
            </v-progress-circular>
        </div>
    </v-container>

    <v-container fluid fill-height v-else>
        <v-layout justify-center row pa-5 v-if="items.length > 0 || filterText || filterStatus !== 'A'">
            <v-flex xs12 sm10 md6>
                <v-flex class="mb-3" text-center>
                    <h2>รายการพัสดุ</h2>
                </v-flex>
                <div v-if="items.length > 0 || filterText || filterStatus !== 'A'">
                    <v-text-field label="ค้นหาบ้านเลขที่"
                                  outlined
                                  v-model="filterText">
                    </v-text-field>

                    <v-radio-group v-model="filterStatus"
                                   row>
                        <v-radio label="ทั้งหมด"
                                 value="A"></v-radio>
                        <v-radio label="รอเข้าตู้"
                                 value="W"></v-radio>
                        <v-radio label="อยู่ในตู้"
                                 value="I"></v-radio>
                    </v-radio-group>
                </div>
                <div class="my-2" v-for="(item, index) in items" :key="index">
                    <v-card class="mx-auto my-2"
                            @click="dialog1 = true;su_runno = item.SU_RUNNO"
                            style="border-left:solid 5px #0045AF;background: #f3f4f6">
                        <v-row>
                            <v-col class="text-center my-auto" cols="4" v-if="item.SU_STATUS === 'W'">
                                <v-icon large color="blue darken-2">mdi-package-variant-closed</v-icon>
                                <br>
                                <span class="overline font-weight-bold" style="color: #0045AF">รอเข้าตู้</span>
                            </v-col>
                            <v-col class="text-center my-auto" cols="4" v-if="item.SU_STATUS === 'C'">
                                <v-icon large color="green darken-2">mdi-package-variant-closed</v-icon>
                                <br>
                                <span class="overline font-weight-bold" style="color: #197c2f">ตัดออก<br>นอกเวลา</span>
                            </v-col>
                            <v-col class="text-center my-auto" cols="4"
                                   v-if="item.SU_STATUS === 'I' && item.ORDER_STATUS === '1'">
                                <v-icon large color="green darken-2">mdi-package-variant-closed</v-icon>
                                <br>
                                <span class="overline font-weight-bold" style="color: #197c2f">อยู่ในตู้<br>Box24</span>
                            </v-col>
                            <v-col class="text-center my-auto" cols="4"
                                   v-if="item.SU_STATUS === 'I' && item.ORDER_STATUS === '3'">
                                <v-icon large color="red darken-2">mdi-package-variant-closed</v-icon>
                                <br>
                                <span class="overline font-weight-bold" style="color: #a70000">อยู่ในตู้<br>Box24 เกินเวลา</span>
                            </v-col>
                            <v-col cols="8">
                                <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                                <v-card-text style="color: #ff2e34">เลขที่อ้างอิง : {{ item.SU_CODE }}</v-card-text>
                                <v-card-text>เวลาที่บันทึก : {{ item.CREATE_DATE.substring(11, 16) }}</v-card-text>
                                <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }}</v-card-text>
                                <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                                <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                                <v-card-text style="color: #000000" v-if="item.location_short_name">ตู้ที่อยู่ :
                                    {{ item.location_short_name }}
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
            </v-flex>
        </v-layout>
        <v-layout justify-center row pa-5 v-else>
            <v-flex class="mb-3" text-center>
                <h2>ไม่มีรายการพัสดุ</h2>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog1" max-width="300">
            <v-card class="pr-8 pl-5">
                <v-row>
                    <v-col cols="12">
                        <v-btn class="ma-2"
                               outlined
                               block
                               @click="updateStatus('S')"
                               color="#0D47A1">
                            รอรับ
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn class="ma-2"
                               outlined
                               block
                               @click="updateStatus('R')"
                               color="#0D47A1">
                            รับแล้ว
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn class="ma-2"
                               outlined
                               block
                               @click="updateStatus('W')"
                               color="#0D47A1">
                            รอเข้าตู้
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn class="ma-2"
                               outlined
                               block
                               @click="updateStatus('I')"
                               color="#0D47A1">
                            อยู่ในตู้
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import EventBus from "@/EventBus";
import axios from "@/axios";

export default {
    name: "StatusChange",
    data() {
        return {
            searchData: {
                ntRunno: this.getLocalItem().nt_runno,
                status: "'W','I','C'",
            },
            items: [],
            itemsDefault: [],
            progress: true,
            today: new Date().toISOString().substr(0, 10),
            filterText: "",
            filterStatus: "A",
            dialog1: false,
            dialog2: false,
            su_runno: '',
        }
    },
    mounted() {
        window.scrollTo(0, 0)
        EventBus.$emit('set_navigation', {title: 'แก้ไขสถานะ', back_route: 'main-menu'});

        this.listParcelOT()
    },
    methods: {
        async listParcelOT() {
            try {
                axios.post('/OTParcelList', this.searchData)
                    .then(res => {
                        console.log('ParcelList', res.data)
                        this.items = res.data.data
                        this.itemsDefault = res.data.data
                        this.progress = false

                        // console.log('groupsDate', this.groupByData(this.items, 'REQUEST_DATE'))
                    })
            } catch (err) {
                console.log(err.message)
            }
        },
        async updateStatus(status) {
            console.log('updateStatus', status, this.su_runno)
            try {
                axios.post('/UpdateStatusParcel', {su_runno: this.su_runno, status: status})
                    .then(res => {
                        console.log('updateStatus', res.data)
                        this.dialog1 = false
                        this.progress = true
                        this.listParcelOT()
                    })
            } catch (err) {
                console.log(err.message)
            }
        }
    },
    watch: {
        filterText: function (val) {
            this.items = this.itemsDefault
            if (this.filterStatus !== 'A') {
                this.items = this.filterObject(this.items, 'SU_STATUS', this.filterStatus)
                this.items = this.filterObject(this.items, 'PD_ADDR', this.filterText)
            }
            if (val) {
                this.items = this.filterObject(this.itemsDefault, 'PD_ADDR', this.filterText)
            } else {
                this.items = this.itemsDefault
            }
        },
        filterStatus: function (val) {
            this.items = this.itemsDefault
            if (this.filterText && val !== 'A') {
                this.items = this.filterObject(this.items, 'SU_STATUS', this.filterStatus)
                this.items = this.filterObject(this.items, 'PD_ADDR', this.filterText)
            } else {
                if (val !== 'A') {
                    this.items = this.filterObject(this.itemsDefault, 'SU_STATUS', this.filterStatus)
                } else {
                    this.filterText = ''
                    this.items = this.itemsDefault
                }
            }
        }
    }
}
</script>

<style scoped>

</style>